import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import AjaxContent from "../../modules/AjaxContent/";
import Modal, { IsModalOpenConsumer } from "../../modules/Modal";
import VideoPlayerEmbed from "./VideoPlayerEmbed";
import videoPlayerRegistry from "./registry/VideoPlayerRegistry";
import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";
import Cookies from "js-cookie";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import { FormOnSubmitSuccessContextProvider } from "../Form";
momentDurationFormatSetup(moment);

var isFormInCookie = function isFormInCookie(gatedCookieId, gatedFormId) {
  var cookie = Cookies.getJSON(gatedCookieId);
  return Boolean(cookie && cookie.forms && cookie.forms.includes(gatedFormId));
};

export var VideoPlayerCore = /*#__PURE__*/function (_Component) {
  _inherits(VideoPlayerCore, _Component);

  var _super = _createSuper(VideoPlayerCore);

  function VideoPlayerCore() {
    var _this;

    _classCallCheck(this, VideoPlayerCore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isActive: false,
      jsonLd: {}
    });

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(VideoPlayerCore.displayName));

    _defineProperty(_assertThisInitialized(_this), "handleClickLoad", function () {
      if (!_this.checkIsGateOpen()) {
        _this.setState({
          isModalOpen: true
        });

        return;
      }

      _this.playVideo();
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseModal", function () {
      _this.setState({
        isModalOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFormComplete", function () {
      _this.setState({
        isModalOpen: false
      });

      if (_this.checkIsGateOpen()) {
        _this.playVideo();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "checkIsGateOpen", function () {
      var _this$props = _this.props,
          gatedFormContentLocation = _this$props.gatedFormContentLocation,
          gatedCookieName = _this$props.gatedCookieName,
          gatedFormId = _this$props.gatedFormId;

      if (gatedFormContentLocation && gatedCookieName && gatedFormId) {
        return isFormInCookie(gatedCookieName, gatedFormId);
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "playVideo", function () {
      videoPlayerRegistry.deactivateAll(_assertThisInitialized(_this));

      _this.setState({
        isActive: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "generateSeoDetails", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props2, description, duration, name, thumbnailUrl, uploadDate, kind, videoId, ldJsonTemplate, seoDetails, response, data, details;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, description = _this$props2.description, duration = _this$props2.duration, name = _this$props2.name, thumbnailUrl = _this$props2.thumbnailUrl, uploadDate = _this$props2.uploadDate, kind = _this$props2.kind, videoId = _this$props2.videoId;
              ldJsonTemplate = {
                "@context": "http://schema.org",
                "@type": "VideoObject",
                description: description,
                duration: duration,
                name: name,
                thumbnailUrl: thumbnailUrl,
                uploadDate: uploadDate
              };

              if (!(kind === "vidyard")) {
                _context.next = 14;
                break;
              }

              _context.next = 5;
              return fetch("https://play.vidyard.com/v4/".concat(videoId, "/details.js"));

            case 5:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 12;
                break;
              }

              _context.next = 9;
              return response.text();

            case 9:
              data = _context.sent;
              details = JSON.parse(data.substring(data.indexOf("(") + 1, data.lastIndexOf(")")));
              seoDetails = _objectSpread(_objectSpread({}, ldJsonTemplate), {}, {
                contentUrl: details.contentUrl,
                embedUrl: details.embedUrl
              });

            case 12:
              _context.next = 15;
              break;

            case 14:
              if (kind === "youtube") {
                seoDetails = _objectSpread(_objectSpread({}, ldJsonTemplate), {}, {
                  contentUrl: "https://youtube.com/watch/?v=".concat(videoId),
                  embedUrl: "https://www.youtube.com/embed/".concat(videoId)
                });
              } else {
                seoDetails = _objectSpread({}, ldJsonTemplate);
              }

            case 15:
              _this.setState({
                jsonLd: seoDetails
              });

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    return _this;
  }

  _createClass(VideoPlayerCore, [{
    key: "deactivate",
    value: function deactivate() {
      if (this.state.isActive) {
        this.setState({
          isActive: false
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.generateSeoDetails();
      videoPlayerRegistry.register(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      videoPlayerRegistry.deregister(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          allowAutoplay = _this$props3.allowAutoplay,
          autoplayInModal = _this$props3.autoplayInModal,
          children = _this$props3.children,
          duration = _this$props3.duration,
          gatedFormContentLocation = _this$props3.gatedFormContentLocation,
          gatedCookieName = _this$props3.gatedCookieName,
          gatedFormId = _this$props3.gatedFormId,
          kind = _this$props3.kind,
          onAjaxChange = _this$props3.onAjaxChange,
          playLabel = _this$props3.playLabel,
          reactFromMarkupOptions = _this$props3.reactFromMarkupOptions,
          reactFromMarkupRehydrators = _this$props3.reactFromMarkupRehydrators,
          videoId = _this$props3.videoId;
      var _this$state = this.state,
          isActive = _this$state.isActive,
          isModalOpen = _this$state.isModalOpen,
          jsonLd = _this$state.jsonLd;
      var durationConverted = moment.duration(duration);
      var formattedDuration = durationConverted.format("hh:mm:ss", {
        stopTrim: "m"
      });
      var content;
      var modal = isModalOpen ? /*#__PURE__*/React.createElement(Modal, {
        ariaLabel: "Gated Video Dialog",
        closeLabel: "Close",
        closeThisComponent: this.handleCloseModal
      }, /*#__PURE__*/React.createElement(FormOnSubmitSuccessContextProvider, {
        value: this.handleFormComplete
      }, /*#__PURE__*/React.createElement(AjaxContent, {
        failedContent: "Failed to retrieve content",
        loadingLabel: "Loading",
        location: gatedFormContentLocation,
        onChange: onAjaxChange,
        reactFromMarkupOptions: reactFromMarkupOptions,
        reactFromMarkupRehydrators: reactFromMarkupRehydrators
      }))) : null;

      if (allowAutoplay || isActive) {
        content = /*#__PURE__*/React.createElement(VideoPlayerEmbed, _extends({
          getClassName: this.getClassName
        }, this.props));
      } else {
        content = /*#__PURE__*/React.createElement("div", {
          className: this.getClassName({
            descendantName: "poster"
          })
        }, /*#__PURE__*/React.createElement("div", {
          className: this.getClassName({
            descendantName: "posterImage"
          }),
          "data-rehydratable-children": true
        }, children), /*#__PURE__*/React.createElement("div", {
          className: this.getClassName({
            descendantName: "duration"
          })
        }, formattedDuration), /*#__PURE__*/React.createElement("button", {
          "aria-label": playLabel,
          className: this.getClassName({
            descendantName: "loadAction"
          }),
          onClick: this.handleClickLoad
        }, /*#__PURE__*/React.createElement("span", {
          className: this.getClassName({
            descendantName: "loadActionInner"
          })
        })));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName(),
        "data-autoplay-in-modal": autoplayInModal,
        "data-duration": duration,
        "data-gated-cookie-name": gatedCookieName,
        "data-gated-form-content-location": gatedFormContentLocation,
        "data-gated-form-id": gatedFormId,
        "data-video-id": videoId,
        "data-kind": kind,
        "data-play-label": playLabel,
        "data-rehydratable": getRehydratableName(VideoPlayerCore.displayName)
      }, /*#__PURE__*/React.createElement("script", {
        type: "application/ld+json"
      }, JSON.stringify(jsonLd)), content, modal);
    }
  }]);

  return VideoPlayerCore;
}(Component);

_defineProperty(VideoPlayerCore, "displayName", "VideoPlayerCore");

_defineProperty(VideoPlayerCore, "defaultProps", {
  gatedCookieName: "tr_ewp_submitted_forms"
});

var VideoPlayerCoreWithContext = function VideoPlayerCoreWithContext(_ref2) {
  var autoplayInModal = _ref2.autoplayInModal,
      props = _objectWithoutProperties(_ref2, ["autoplayInModal"]);

  return /*#__PURE__*/React.createElement(IsModalOpenConsumer, null, function (isModalOpen) {
    return /*#__PURE__*/React.createElement(VideoPlayerCore, _extends({}, props, {
      allowAutoplay: autoplayInModal && isModalOpen,
      autoplayInModal: autoplayInModal
    }));
  });
};

VideoPlayerCoreWithContext.displayName = "VideoPlayerCore";
export default VideoPlayerCoreWithContext;